<script>
  // # # # # # # # # # # # # # # # # #
  //
  //  Listing of exhibitions/projects
  //
  // # # # # # # # # # # # # # # # # #

  // *** IMPORT
  import { onMount } from "svelte";
  import { feedActive } from "../stores.js";
  import ListItem from "../Components/ListItem.svelte";

  // *** PROPS
  export let title = "";
  export let endpoint = "";

  // *** VARIABLES
  let items = [];
  let url = "";
  let sentinel;
  let containerEl;
  let meta = {};
  let finishedLoading = false;
  let index = 0;
  let firstLoad = false;

  feedActive.set(false);

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0 && firstLoad) {
          if (meta.nextindex < meta.lastindex) {
            loadData(meta.nextindex);
          } else {
            observer.disconnect();
            finishedLoading = true;
          }
        }
      });
    },
    { treshhold: 0.5 }
  );

  const repositionSentinel = () => {
    if (containerEl && sentinel) {
      const fourthElementFromEnd = containerEl.querySelector(
        ".list-item-container:nth-last-child(4)"
      );
      if (fourthElementFromEnd) {
        containerEl.insertBefore(sentinel, fourthElementFromEnd);
      }
    }
  };

  const loadData = i => {
    url = endpoint + "/index:" + i;
    fetch(url)
      .then(r => r.json())
      .then(arr => {
        firstLoad = true;
        items = [...items, ...arr.posts];
        meta = arr.meta;
        setTimeout(repositionSentinel, 500);
      })
      .catch(e => {
        console.log(e);
      });
  };

  loadData(index);

  onMount(async () => {
    window.scrollTo(0, 0);
    observer.observe(sentinel);
  });
</script>

<style lang="scss">
  @import "../_variables.scss";

  .sentinel {
    line-height: 0;
    height: 1px;
  }
</style>

<svelte:head>
  <title>{title.toUpperCase()} | COMPLETE WORKS</title>
</svelte:head>

<div class="list">

  <div class="container" bind:this={containerEl}>
    {#each items as item}
      <ListItem {item} />
    {/each}
  </div>

  {#if !finishedLoading}
    <div class="sentinel" bind:this={sentinel} />
  {/if}

</div>
